var _path, _rect, _rect2, _rect3, _rect4, _circle, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvent24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.75H15",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 13.5,
    width: 3,
    height: 1.5,
    className: "filled",
    fill: "currentColor",
    strokeWidth: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 13.5,
    width: 1.5,
    height: 1.5,
    className: "filled",
    fill: "currentColor",
    strokeWidth: 0
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 16.5,
    width: 3,
    height: 1.5,
    className: "filled",
    fill: "currentColor",
    strokeWidth: 0
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 16.5,
    width: 1.5,
    height: 1.5,
    className: "filled",
    fill: "currentColor",
    strokeWidth: 0
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.25,
    cy: 9.75,
    r: 0.75,
    className: "filled",
    fill: "currentColor",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3C7.5 2.58579 7.83579 2.25 8.25 2.25C8.66421 2.25 9 2.58579 9 3V7.5H7.5V3Z",
    className: "filled",
    fill: "currentColor",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3C15 2.58579 15.3358 2.25 15.75 2.25C16.1642 2.25 16.5 2.58579 16.5 3V7.5H15V3Z",
    className: "filled",
    fill: "currentColor",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 6H19.5V19.5H12V21H19.5C20.3284 21 21 20.3284 21 19.5V6C21 5.17157 20.3284 4.5 19.5 4.5H4.5C3.67157 4.5 3 5.17157 3 6V12H4.5L4.5 6Z",
    className: "filled",
    fill: "currentColor",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.8418 17.625C2.8418 15.7776 4.3394 14.28 6.18679 14.28C8.03417 14.28 9.53177 15.7776 9.53177 17.625C9.53177 19.4724 8.03417 20.97 6.18679 20.97C4.3394 20.97 2.8418 19.4724 2.8418 17.625ZM6.18679 12.78C3.51097 12.78 1.3418 14.9492 1.3418 17.625C1.3418 20.3008 3.51097 22.47 6.18679 22.47C8.8626 22.47 11.0318 20.3008 11.0318 17.625C11.0318 14.9492 8.8626 12.78 6.18679 12.78ZM7.86257 15.8348L5.55791 18.1395L4.51324 17.0948L3.45258 18.1555L4.89499 19.5979C5.26111 19.964 5.8547 19.964 6.22082 19.5979L8.92323 16.8955L7.86257 15.8348Z",
    className: "filled",
    fill: "currentColor",
    strokeWidth: 0
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent24);
export default __webpack_public_path__ + "static/media/Event-24.5a34dd20.svg";
export { ForwardRef as ReactComponent };